// import React from "react";
// import { Route, Redirect } from "react-router-dom";

// function PrivateRoute({ component: Component, ...rest }) {
//   const token = window.localStorage.getItem("token");
//   return (
//     <Route
//       {...rest}
//       component={(props) => {
//         if (token) {
//           return <Component {...props} />;
//         } else {
//           return <Redirect to={"/"} />;
//         }
//       }}
//     />
//   );
// }

// export default PrivateRoute;

import React from "react";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({ component: Component, children, ...rest }) {
  const token = window.localStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          Component ? (
            <Component {...props} />
          ) : (
            children
          )
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default PrivateRoute;
